import InformationBox from '../../components/other/informationBox';
import AgyleBlockSwitch from '../../components/ui/switch/agyleBlockSwitch';
import {FormLabel} from '@mui/material';
import AgyleDictionaryField from '../../components/ui/selector/agyleDictionaryField';
import React, {useState} from 'react';
import useDict from '../../hooks/useDict';
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from 'react-i18next';
import MessageBox from '../../util/messageBox';
import AgyleTextField from '../../components/ui/fields/agyleTextField';
import {isEmpty} from 'lodash';
import Notes from '../../util/notes';
import moment from 'moment';
import {useSelector} from 'react-redux';
import {user} from '../../store/reducers/user';
import Formatter from '../../util/formatter';

const useStyles = makeStyles((theme) => {
    return {
        divRow: {
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            alignItems: 'center',
            width: '100%',
        },
    };
});

const EmptyDiagnosisDialog = ({open, patient, onSave, onClose}) => {
    const classes = useStyles();
    const {t} = useTranslation();

    // user
    const userObject = useSelector(user);
    const userFullName = Formatter.formatUserFullName(userObject);

    // States
    const [emptyDiagnosisDict, emptyDiagnosisDictLoading] = useDict('DiagnosisNotRequireReasons');
    const [emptyDiagnosisSwitch, setEmptyDiagnosisSwitch] = useState(false);
    const [emptyDiagnosisReason, setEmptyDiagnosisReason] = useState(null);
    const [emptyDiagnosisText, setEmptyDiagnosisText] = useState('');

    if (!open) return null;

    const renderBody = () => {
        return (
            <>
                <InformationBox type="warning">
                    {t('Please enter a diagnosis.')}
                </InformationBox>

                <div className={classes.divRow}>
                    <AgyleBlockSwitch
                        onChange={setEmptyDiagnosisSwitch}
                        value={emptyDiagnosisSwitch}
                    />

                    <FormLabel style={{marginLeft: 5}}>
                        {t('Diagnosis not required')}
                    </FormLabel>
                </div>

                {emptyDiagnosisSwitch &&
                    <div style={{marginTop: 10}}>
                        <AgyleDictionaryField
                            onChange={(_e, val) => setEmptyDiagnosisReason(val)}
                            value={emptyDiagnosisReason}
                            options={emptyDiagnosisDict}
                            loading={emptyDiagnosisDictLoading}
                            label={t('Select Reason')}
                            style={{marginBottom: 10}}
                            size="large"
                            noBorder={false}
                            withNewBackground
                        />

                        <AgyleTextField
                            label={t('Info')}
                            value={emptyDiagnosisText}
                            onChange={e => setEmptyDiagnosisText(e.target.value)}
                            fullWidth
                            size="large"
                            noBorder={false}
                            withNewBackground
                        />
                    </div>
                }
            </>
        );
    };

    const clearForm = () => {
        setEmptyDiagnosisSwitch(false);
        setEmptyDiagnosisReason(null);
        setEmptyDiagnosisText('');
    };

    const handleClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            clearForm();
            onClose();
        }
    };

    const handleSave = () => {
        const data = {
            acknowledge: true,
            reason: emptyDiagnosisReason,
            text: emptyDiagnosisText,
            timestamp: moment().toISOString(),
            user: userFullName,
            userLogin: userObject?.userName,
        };

        onSave([{
            name: 'metadata.diagnosisNotRequired',
            value: data,
            noteToAdd: Notes.getEmptyDiagnosisNote(data),
        }]);

        clearForm();
        onClose();
    };

    return (
        <MessageBox
            title={t('Empty Diagnosis')}
            haveAccept={{yes: t('Submit'), no: t('Acknowledge')}}
            onAccept={handleSave}
            onClose={handleClose}
            messageObject={renderBody()}
            open={open}
            width={'xs'}
            fullWidth
            disableSave={isEmpty(emptyDiagnosisReason) && isEmpty(emptyDiagnosisText)}
            disabled={true}
        />
    );
};

export default EmptyDiagnosisDialog;